<!-- History -->

<div class="" *ngIf="section === 'History'">
  <div class="ttm-page-title-row ttm-bgcolor-whiteecolor">
    <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="title-box ">
            <div class="page-title-heading text-white">
              <h1 class="title text-white">About Us</h1>
            </div><!-- /.page-title-captions -->
            <div class="breadcrumb-wrapper">
              <span>
                <i class="fa fa-home text-white"></i> <a class="title text-white">Home</a>

              </span>
              <span class="ttm-bread-sep text-white"> <strong>&nbsp; :&nbsp;: &nbsp;</strong> </span>
              <span><span class="ttm-textcolor-skincolor" style="font-size: 16px;">About Us</span></span>
            </div>
          </div>
        </div><!-- /.col-md-12 -->
      </div><!-- /.row -->
    </div><!-- /.container -->
  </div>
  <!-- <div class="container ttm-bgcolor-whiteecolor">
    <div class="row mt-3 ttm-bgcolor-whiteecolor">

      <h4 class="title text-left ml-3 " style="font-size: 35PX;">Welcome to Nisargopchar Ashram</h4>

      <p class="para-color mt-3 ml-3 mb-4" style="text-align:justify; font-size: 16px;">Along with mahatma
        Gandhiji, the founder many great souls had devoted their lives to uplift the declining health of the
        rural community by being a part of Nisargopchar Ashram. Prominent among them were Shri. Manibhai Desai,
        Shri. Balkoba Bhave, Smt. Gangabehn Bhate, Shri. Vishnupant Gokhale, Smt. Hoshyaribehn Bohare and
        Shri.Ganesh Behede. Their commitment, simplicity and sincerity are left behind as a source of
        inspiration for us. </p>
    </div>
  </div> -->

  <!-- History of ashram-->
  <!-- <section class="ttm-bgcolor-whiteecolor clearfix">
    <div class="container">
      <div class="row">
        <div
          class="col-lg-6 col-md-12 col-sm-12 featured-imagebox featured-imagebox-service ttm-box-view-top-image mt-40">
          <div class="ttm-box-bottom-content mt-3 ttm-bgcolor-whiteecolor">
            <div class="featured-icon">
              <div
                class="ttm-icon ttm-icon_element-fill ttm-icon_element-background-color-skincolor ttm-icon_element-size-md ttm-icon_element-style-rounded">
                <i class="flaticon flaticon-meditation"></i>
              </div>
            </div>
            <div class="title text-left ml-4">
              <div class="col-lg"></div>
              <h5><strong>History of Ashram </strong></h5>
            </div>
            <div class="col-lg mt-3 mb-"></div>
            <div class="featured-desc ml-2" style="text-align:center;">
              <p class="para-color"
                style="text-align:justify; display:inline-block; width:90%; text-align: center; text-align: justify;">
                Gandhiji came to Uruli Kanchan on 22nd March 1946 at 16.00hrs and stayed for up to 30th
                March 1946. He treated hundreds of patients with the help of Dr. Mehta, Balkobaji Bhave,
                Manibhai Desai , Dr. Sushila Nair and other disciples. Gandhiji founded Nisargopchar
                Gramsudhar Trust on 1st April 1946, with the help of kind donations in the form of Land
                by local people like late Shri Mahadev Tatyaba Kanchan. The team under the dynamic
                leadership of Manibhaiji preached sound health and hygienic practices and also studied
                various problems in rural areas and identified suitable solutions to uplift the rural
                poor.
              </p>


            </div>

          </div>
          <div class="ttm-box-bottom-content mt-3 ttm-bgcolor-whiteecolor">
            <div class="featured-icon">
              <div
                class="ttm-icon ttm-icon_element-fill ttm-icon_element-background-color-skincolor ttm-icon_element-size-md ttm-icon_element-style-rounded">
                <i class="flaticon flaticon-meditation"></i>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-lg-6 col-md-12 col-sm-12 featured-imagebox featured-imagebox-service ttm-box-view-top-image text-center ">
          <div class="ttm-box-bottom-content mt-3 ttm-bgcolor-whiteecolor">
            <div class="featured-icon">
              <div
                class="ttm-icon ttm-icon_element-fill ttm-icon_element-background-color-skincolor ttm-icon_element-size-md ttm-icon_element-style-rounded">
                <i class="flaticon flaticon-meditation"></i>
              </div>
            </div>
            <img class="w-60 text-center" src="assets/img/history.jpeg" alt="First slide" width="400" height="200">
          </div>
          <div class="ttm-box-bottom-content mt-3 ttm-bgcolor-whiteecolor">
            <div class="featured-icon">
              <div
                class="ttm-icon ttm-icon_element-fill ttm-icon_element-background-color-skincolor ttm-icon_element-size-md ttm-icon_element-style-rounded">
                <i class="flaticon flaticon-meditation"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section> -->

  <div class="container" style="padding: 40px 20px;">
    <!-- Welcome Title -->
    <div style="margin-bottom: 30px;">
      <h4 style="font-size: 35px; font-weight: bold; color: #2c3e50;">Welcome to Nisargopchar Ashram</h4>
      <p style="font-size: 16px; line-height: 1.6; text-align: justify; margin-top: 15px;">
        Along with Mahatma Gandhiji, many great souls devoted their lives to uplift the declining health of the rural
        community by being a part of Nisargopchar Ashram. Prominent among them were Shri. Manibhai Desai,
        Shri. Balkoba Bhave, Smt. Gangabehn Bhate, Shri. Vishnupant Gokhale, Smt. Hoshyaribehn Bohare and
        Shri. Ganesh Behede. Their commitment, simplicity, and sincerity remain a source of inspiration.
      </p>
    </div>

    <!-- History + Image Row -->
    <!-- <div class="row" style="display: flex; flex-wrap: wrap; gap: 30px;">
      <div class="col-lg-6" style="flex: 1; min-width: 300px;">
        <div
          style="padding: 20px; background-color: #ffffff; border-radius: 10px; box-shadow: 0 2px 8px rgba(0,0,0,0.05);">
          <h5 style="font-size: 22px; color: #2c3e50; margin-bottom: 15px;">
            <i class="flaticon flaticon-meditation" style="margin-right: 8px; color: #27ae60;"></i>
            History of Ashram
          </h5>
          <p style="font-size: 15px; line-height: 1.7; text-align: justify;">
            Gandhiji came to Uruli Kanchan on 22nd March 1946 at 16.00hrs and stayed until 30th March 1946. He treated
            hundreds of patients with the help of Dr. Mehta, Balkobaji Bhave, Manibhai Desai, Dr. Sushila Nair, and
            other disciples. Gandhiji founded the Nisargopchar Gramsudhar Trust on 1st April 1946 with generous
            land donations from locals such as late Shri Mahadev Tatyaba Kanchan. Under Manibhaiji’s leadership,
            the team promoted hygiene and studied rural issues to find health-based solutions.
          </p>
        </div>
      </div>

      <div class="col-lg-6" style="flex: 1; min-width: 300px; text-align: center;">
        <img src="assets/img/history.jpeg" alt="History of Ashram"
          style="width: 100%; max-width: 350px; height: auto; border-radius: 10px; box-shadow: 0 2px 8px rgba(0,0,0,0.05);">
      </div>
    </div> -->

    <div class="row" style="display: flex; flex-wrap: wrap; gap: 30px; align-items: center;">
      <!-- History Text -->
      <div class="col-lg-6" style="flex: 1; min-width: 300px;">
        <div
          style="padding: 20px; background-color: #ffffff; border-radius: 10px; box-shadow: 0 2px 8px rgba(0,0,0,0.05);">
          <strong style="font-size: 22px; color: #2c3e50; margin-bottom: 15px;">
            <i class="flaticon flaticon-meditation" style="margin-right: 8px; color: #27ae60;"></i>
            History of Ashram
          </strong>
          <p style="font-size: 15px; line-height: 1.7; text-align: justify;">
            Gandhiji came to Uruli Kanchan on 22nd March 1946 at 16.00hrs and stayed until 30th March 1946. He treated
            hundreds of patients with the help of Dr. Mehta, Balkobaji Bhave, Manibhai Desai, Dr. Sushila Nair, and
            other disciples. Gandhiji founded the Nisargopchar Gramsudhar Trust on 1st April 1946 with generous
            land donations from locals such as late Shri Mahadev Tatyaba Kanchan. Under Manibhaiji’s leadership,
            the team promoted hygiene and studied rural issues to find health-based solutions.
          </p>

          <!-- <p class="para-color"
              style="text-align:justify; display:inline-block; width:90%; text-align: center; text-align: justify;">
              He wrote an article in Harijan, “I made a mistake, I should have gone to the village to
              popularize simple ways of Nature Cure, therefore I want to shift.”
          </p>
          <p class="para-color"
              style="text-align:justify; display:inline-block; width:90%; text-align: center; text-align: justify;">
              Search began for a proper place around Pune. Late Shri. Balkoba Bhave, Dr. Mehta, Dr.
              Sushila Nair, Dr. Manibhai Desai came to Uruli Kanchan. To their disappointment they
              found that social atmosphere was not conducive for establishing a Nature Cure Center,
              but Gandhiji insisted that he wanted the village like Uruli, because unless he is able
              to improve condition of rural India, he will not be able to work at Delhi for
              independent India.
          </p>
          <p class="para-color"
              style="text-align:justify; display:inline-block; width:90%; text-align: center; text-align: justify;">
              Gandhiji came to Uruli Kanchan on 22nd March 1946 at 16.00hrs. and stayed for up to 30th
              March 1946. He treated hundreds of patients with the help of Dr. Mehta, Balkobaji Bhave,
              Manibhai Desai , Dr. Sushila Nair and other disciples.On 30th March 1946, Mahatma Gandhi
              departed for Delhi for the final negotiations with British Government regarding
              Independent India.
          </p>
          <p class="para-color"
              style="text-align:justify; display:inline-block; width:90%; text-align: center; text-align: justify;">
              Gandhiji founded Nisargopchar Gramsudhar Trust on 1st April 1946, with the help of kind
              donations in the form of Land by local people like late shri Mahadev Tatyaba Kanchan.
              The team under the dynamic leadership of Manibhaiji preached sound health and hygienic
              practices and also studied various problems in rural areas and identified suitable
              solutions to uplift the rural poor.
              Over last fifty years the Ashram has made remarkable progress. The institute has set up
              the unique example in the field of Naturopathy i.e. “The way of Life”. People from every
              corner of India and abroad come here and experience the miracles of the unique drugless
              holistic approach for management of chronic functional diseases. Patients suffering from
              Arthritis, Cardio Vascular diseases, Diabetes, Bronchitis, skin diseases, Asthma.
              Digestive and Gynaecological problems, Neuro muscular disorders & obesity are very well
              managed by simple ways of nature cure. Day in the Ashram begins with prayer & yoga and
              ends with prayer.
              Thus along with other physical treatments, psychological and spiritual aspect is taken
              care of to make the treatment complete.Every day lectures on nature cure principles,
              dietetics,yoga and various chronic diseases are arranged to educate the patients and
              make them aware about the importance of laws of nature. Round the year Ashram has indoor
              capacity of 200 patients per day.
          </p> -->
        </div>
      </div>

      <!-- Image -->
      <div class="col-lg-6" style="flex: 1; min-width: 300px; text-align: center;">
        <img src="assets/img/history.jpeg" alt="History of Ashram"
          style="width: 100%; max-width: 350px; height: auto; border-radius: 10px; box-shadow: 0 2px 8px rgba(0,0,0,0.05);">
      </div>
    </div>


    <!-- Objectives of the Trust -->
    <div
      style="margin-top: 30px; padding: 20px; background-color: #ffffff; border-radius: 10px; box-shadow: 0 2px 8px rgba(0,0,0,0.05);">
      <strong style="font-size: 22px; color: #2c3e50; margin-bottom: 20px;">
        <i class="flaticon flaticon-meditation" style="margin-right: 8px; color: #27ae60;"></i>
        Objectives of the Trust
      </strong>
      <ol style="font-size: 15px; line-height: 1.7; text-align: justify; padding-left: 18px;">
        <li>To extend the healing touch of Naturopathy and Yoga to all, especially the poor and needy in rural and
          underserved regions, upholding the Gandhian spirit of compassion and equality.</li>
        <li>To ensure a self-reliant and health-conscious society through the promotion of natural living, personal
          hygiene, sanitation, and access to safe drinking water.</li>
        <li>To prioritize women’s health and empowerment, enabling them to be torchbearers of holistic wellness within
          their families and communities.</li>
        <li>To provide affordable, authentic, and ethical healthcare to all sections of society, without discrimination,
          anchored in the principle of Sarvodaya (welfare of all).</li>
        <li>To awaken health awareness in village communities, enriching their knowledge and encouraging preventive,
          nature-based approaches to wellness.</li>
        <li>To revive and propagate the Indian systems of Naturopathy and Yoga, ensuring their reach to every household
          in a culturally rooted and accessible manner.</li>
        <li>To support and guide traditional healers and local health workers, integrating them into the national
          framework of holistic and community-based health.</li>
        <li>To organize regular health awareness camps, training programs, and exhibitions, for public education and
          active community engagement in health promotion.</li>
        <li>To encourage and conduct research, education, and training activities in the fields of Naturopathy, Yoga,
          and public health with a focus on community empowerment.</li>
        <li>To publish books, periodicals, charts, and IEC materials, aimed at spreading health literacy—particularly
          among women, children, and elders—through simple, accessible communication.</li>
      </ol>
    </div>
  </div>
</div>

<!-- Object of the trust -->

<div class="" *ngIf="section === 'Objectofthetrust'">

  <div class="ttm-page-title-row ttm-bgcolor-whiteecolor">
    <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="title-box ">
            <div class="page-title-heading text-white">
              <h1 class="title text-white">Objectives Of The Trust</h1>
            </div><!-- /.page-title-captions -->
          </div>
        </div><!-- /.col-md-12 -->
      </div><!-- /.row -->
    </div><!-- /.container -->
  </div>
  <div class="contact mt-2 ttm-bgcolor-whiteecolor">
    <div class="row mr-3">
      <div class="col-lg-1"></div>
      <div class="col-lg featured-imagebox featured-imagebox-service ttm-box-view-top-image mt-40">
        <div class="ttm-box-bottom-content mt-5 ttm-bgcolor-whiteecolor">
          <div class="featured-desc ml-4 mr-4" style="text-align:center;">
            <p class="para-color mt-4"
              style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
              Gandhiji has laid the foundation of Nature cure Ashram at Urulikanchan, an interior village of Maharashtra
              by keeping in mind the principles of Gram swaraj and Swasth Swalamban. He believed that prosperity of the
              country depends on the health and wellness of the village. He believed that it is important for villages
              to be self-sufficient and have health in place by being close to Nature.</p>
            <!-- <p class="para-color mt-1 ml-3"
              style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
              To extend the health care services especially the Naturopathy & Yoga to everyone including
              the needy & poor located in remote areas.</p>
            <p class="para-color mt-1 ml-3"
              style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
              To attain self-reliance through self-health reliance to ensure that entire nation is built
              on a strong foundation of Healthy lifestyle, proper hygienic measures, good sanitation
              facilities & safe water drinking.</p>
            <p class="para-color mt-1 ml-3 "
              style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
              To emphasize on women's health & women empowerment in order to promote and implement a
              sustainable health plan through the women in the societies, which is the core ingredient of
              a developed county.</p>
            <p class="para-color mt-1 ml-3"
              style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
              To ensure affordable, authentic health care services to be extended to each section of
              society based on equanimity.</p>
            <p class="para-color mt-1 ml-3"
              style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
              He always worked & shared his wisdom to improve the knowledge base amount the villages by
              providing them ideas related valuable, sustainable live hood adjoining health needs of the
              society.</p>
            <p class="para-color mt-1 ml-3"
              style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
              To promote & propagate naturopathy & yoga among the citizen India to preach & practice the
              noble science. And lead a simple yet healthy & meaningful life.</p>
            <p class="para-color mt-1 ml-3"
              style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
              To develop and mobilize the community & national resources to give the right direction to
              people of marginalized and economically weaker section of society towards sustainable over
              all development.</p>
            <p class="para-color mt-1 ml-3"
              style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
              To organize and conduct various health programs awareness camps, workshops and exhibitions
              for the common public.</p>
            <p class="para-color mt-1 ml-3"
              style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
              To promote, encourage and facilitate research programs, training and activities related to
              Naturopathy Yoga, public health and empowerment.</p>
            <p class="para-color mt-1 ml-3"
              style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
              To publish books, magazines, chars, issue related IEC materials for sanitizing the common
              public specifically to women, children and senior citizens.</p> -->
          </div>
        </div>
      </div>
      <div class="col-lg-1"></div>
    </div>
    <div class="col-lg mt-5 mb-5"></div>
  </div>
</div>

<!-- Trustees -->

<div class=" ttm-bgcolor-whiteecolor" *ngIf="section == 'Trustees'">

  <div class="ttm-page-title-row ttm-bgcolor-whiteecolor">
    <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="title-box ">
            <div class="page-title-heading text-white">
              <h1 class="title text-white">Trustees</h1>
            </div><!-- /.page-title-captions -->
          </div>
        </div><!-- /.col-md-12 -->
      </div><!-- /.row -->
    </div><!-- /.container -->
  </div>

  <div class="ttm-bgcolor-whiteecolor">
    <div class="container text-center py-5">
      <div class="row g-4 justify-content-center">
        <div class="col-md-6 col-lg-3 mt-3" *ngFor="let Trustee of Trustees">
          <div class="doctor-card shadow-lg rounded-4 text-center p-4">
            <div class="doctor-img-wrapper mb-2">
              <img [src]="Trustee.image" alt="{{Trustee.name}}" class="img-fluid shadow">
            </div>
            <h5 class="fw-bold">{{ Trustee.name }}</h5>
            <p class="text-muted">{{ Trustee.specialization }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="container ttm-bgcolor-whiteecolor">
    <div class="row mt-5">
      <div class="col-md-6 col-lg-3">
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail">
              <img class="img-fluid" src="assets/img/Mafatlal.jpeg" alt="">
            </div>
          </div>
          <div class="featured-content featured-content-team">
            <div class="featured-title">
              <h5><a>Shri. Hrishikesh A. Mafatlal</a></h5>
            </div>
            <div class="ttm-team-position text-black" style="font-size: 20px;"> Chairman </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-lg-3">
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail">
              <img class="img-fluid" src="assets/img/Narayan-Hegde.jpg" alt="">
            </div>
          </div>
          <div class="featured-content featured-content-team">
            <div class="featured-title">
              <h5><a>Dr. Narayan G. Hegde</a></h5>
            </div>
            <div class="ttm-team-position text-black" style="font-size: 20px;"> Managing Trustee </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-lg-3">
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail">
              <img class="img-fluid" src="assets/img/Girish-Sohani.jpg" alt="">
            </div>
          </div>
          <div class="featured-content featured-content-team">
            <div class="featured-title">
              <h5><a>Shri. Girish G. Sohani</a></h5>
            </div>
            <div class="ttm-team-position text-black" style="font-size: 20px;"> Trustee </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-lg-3">
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail">
              <img class="img-fluid" src="assets/img/Dnynoba Kanchan.jpeg" alt="">
            </div>
          </div>
          <div class="featured-content featured-content-team">
            <div class="featured-title">
              <h5><a>Shri. Dnynoba T. Kanchan</a></h5>
            </div>
            <div class="ttm-team-position text-black" style="font-size: 20px;"> Trustee </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3 mt-5">
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail">
              <img class="img-fluid" src="assets/img/Bharat Kakade.jpg" alt="">
            </div>
          </div>
          <div class="featured-content featured-content-team">
            <div class="featured-title">
              <h5><a>Dr. Bharat Kakade</a></h5>
            </div>
            <div class="ttm-team-position text-black" style="font-size: 20px;"> Trustee
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3 mt-5">
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail">
              <img class="img-fluid" src="assets/img/Dr.AbhishekD.jpeg" alt="">
            </div>
          </div>
          <div class="featured-content featured-content-team">
            <div class="featured-title">
              <h5><a>Dr Abhishek Devikar</a></h5>
            </div>
            <div class="ttm-team-position text-black" style="font-size: 20px;"> Medical Director & Trustee
              Secretary
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg mt-5 mb-5"></div>
    </div>
    <div class="col-lg mt-5 mb-5"></div>
  </div> -->
</div>

<!-- Doctors -->

<div class=" ttm-bgcolor-whiteecolor" *ngIf="section == 'Doctors'">
  <div class="ttm-page-title-row ttm-bgcolor-whiteecolor">
    <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="title-box ">
            <div class="page-title-heading text-white">
              <h1 class="title text-white">Our Healing Team</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="ttm-bgcolor-whiteecolor">
    <div class="container text-center py-5">
      <div class="row g-4 justify-content-center">
        <div class="col-md-6 col-lg-3 mt-3" *ngFor="let doctor of doctors" (click)="openDoctorModal(contentDD,doctor)">
          <div class="doctor-card shadow-lg rounded-4 text-center p-4">
            <div class="doctor-img-wrapper mb-2">
              <img [src]="doctor.image" alt="{{doctor.name}}" class="img-fluid shadow">
            </div>
            <h5 class="fw-bold">{{ doctor.name }}</h5>
            <p class="text-muted">{{ doctor.specialization }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- <div class="container ttm-bgcolor-whiteecolor">

    <div class="row mt-5">
      <div class="col-md-6 col-lg-3" (click)="GetDoctorDescription('dr_Abhishek_Devikar')">
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail">
              <img class="img-fluid" src="assets/img/Dr.AbhishekD.jpeg" alt="">
            </div>
          </div>
          <div class="featured-content featured-content-team">
            <div class="featured-title mt-2">
              <h5><a>Dr. Abhishek Devikar</a></h5>
            </div>

          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3" (click)="GetDoctorDescription('dr_Ameya_Devikar')">
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail">
              <img class="img-fluid" src="assets/img/Dr.AmeyaD.png" alt="">
            </div>
          </div>
          <div class="featured-content featured-content-team">
            <div class="featured-title mt-2">
              <h5><a>Dr. Ameya Devikar</a></h5>
            </div>

          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3" (click)="GetDoctorDescription('dr_Vandita_Bagul')">
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail">
              <img class="img-fluid" src="assets/img/Dr.VanditaB.jpeg" alt="">
            </div>
          </div>
          <div class="featured-content featured-content-team">
            <div class="featured-title mt-2">
              <h5><a>Dr. Vandita Bagul</a></h5>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3" (click)="GetDoctorDescription('dr_Samruddhi_Vyas')">
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail">
              <img class="img-fluid" src="assets/img/Dr.SamruddhiV.jpeg" alt="">
            </div>
          </div>
          <div class="featured-content featured-content-team">
            <div class="featured-title mt-2">
              <h5><a>Dr. Samruddhi Vyas</a></h5>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3 mt-5" (click)="GetDoctorDescription('dr_Shanu_Mishra')">
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail">
              <img class="img-fluid" src="assets/img/Dr. Shanu Mishra.jpeg" alt="">
            </div>
          </div>
          <div class="featured-content featured-content-team">
            <div class="featured-title mt-2">
              <h5><a>Dr. Shanu Mishra</a></h5>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3 mt-5" (click)="GetDoctorDescription('dr_Shubhada_Thorat')">
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail">
              <img class="img-fluid" src="assets/img/Dr. Shubhada.jpeg" alt="">
            </div>
          </div>
          <div class="featured-content featured-content-team">
            <div class="featured-title mt-2">
              <h5><a>Dr. Shubhada Thorat</a></h5>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3 mt-5" (click)="GetDoctorDescription('dr_Harshini_Nagula')">
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail">
              <img class="img-fluid" src="assets/img/Dr. Harshini.jpeg" alt="">
            </div>
          </div>
          <div class="featured-content featured-content-team">
            <div class="featured-title mt-2">
              <h5><a>Dr. Harshini Nagula</a></h5>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3 mt-5" (click)="GetDoctorDescription('dr_Shubham_Doifode')">
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail">
              <img class="img-fluid" src="assets/img/Dr. Shubham Doifode.jpeg" alt="">
            </div>
          </div>
          <div class="featured-content featured-content-team">
            <div class="featured-title mt-2">
              <h5><a>Dr. Shubham Doifode</a></h5>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-lg-3 mt-5" (click)="GetDoctorDescription('dr_Jay_Mahajan')">
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail">
              <img class="img-fluid" src="assets/img/Dr Jay Mahajan.jpeg" alt="">
            </div>
          </div>
          <div class="featured-content featured-content-team">
            <div class="featured-title mt-2">
              <h5><a>Dr. Jay Mahajan</a></h5>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-lg-3 mt-5" (click)="GetDoctorDescription('dr_Shubhangi_Saxena')">
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail">
              <img class="img-fluid" src="assets/img/Dr Shubhangi Saxena.jpeg" alt="">
            </div>
          </div>
          <div class="featured-content featured-content-team">
            <div class="featured-title mt-2">
              <h5><a>Dr. Shubhangi Saxena</a></h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg mt-5 mb-5 ttm-bgcolor-whiteecolor"></div>
  </div> -->
</div>

<!-- New Profile Style Modal -->
<!-- Doctor Modal Template -->
<ng-template #contentDD let-close="close" let-dismiss="dismiss">
  <div class="modal-content profile-modal">
    <button type="button" class="btn-close btn-close-white ms-auto m-3" (click)="close()"></button>
    <div class="text-center">
      <img [src]="selectedDoctor?.image" class="profile-img shadow-lg" alt="{{selectedDoctor?.name}}">
      <h3 class="mt-3 fw-bold">{{ selectedDoctor?.name }}</h3>
      <h4 class="mt-3 fw-bold">{{ selectedDoctor?.degree }}</h4>
      <h5 class="text-warning">{{ selectedDoctor?.specialization }}</h5>
      <label class="mt-3 px-4 text-muted" [innerHTML]="selectedDoctor?.description"></label>

      <!-- <p class="mt-3 px-4 text-muted">{{ selectedDoctor?.description }}</p> -->
    </div>
    <div class="text-center pb-4">
      <button class="btn btn-primary px-4" (click)="close()">Close</button>
    </div>
  </div>
</ng-template>

<!-- A day At Ashram -->

<!-- <div class=" ttm-bgcolor-whiteecolor" *ngIf="section == 'AdayAtAshram'">
  <div class="ttm-page-title-row ttm-bgcolor-whiteecolor">
    <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="title-box ">
            <div class="page-title-heading text-white">
              <h1 class="title text-white">A day At Ashram</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container ttm-bgcolor-whiteecolor mt-5">

    <div class="et_pb_section et_section_regular">
      <div class="et_pb_row">
        <div data-elementor-type="wp-page" data-elementor-id="4518" class="elementor elementor-4518"
          data-elementor-post-type="page">
          <section
            class="elementor-section elementor-top-section elementor-element elementor-element-2c17181 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="2c17181" data-element_type="section">
            <div class="elementor-container elementor-column-gap-default">
              <div
                class="elementor-column elementor-col-16 elementor-top-column elementor-element elementor-element-6bb6126"
                data-id="6bb6126" data-element_type="column">
                <div class="elementor-widget-wrap"></div>
              </div>
              <div
                class="elementor-column elementor-col-66 elementor-top-column elementor-element elementor-element-81a5a18"
                data-id="81a5a18" data-element_type="column">
                <div class="elementor-widget-wrap elementor-element-populated">
                  <div class="elementor-element elementor-element-eddd29c elementor-widget elementor-widget-html"
                    data-id="eddd29c" data-element_type="widget" data-widget_type="html.default">
                    <div class="elementor-widget-container">
                      <table class="my-table text-left ml-4 ">
                        <thead>
                          <tr>
                            <th>Timing</th>
                            <th>Work</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>5.00 AM</td>
                            <td>Waking Up</td>
                          </tr>
                          <tr>
                            <td>5.15-6.00 AM</td>
                            <td>Power Yoga(Yogasadhana Hall)</td>
                          </tr>
                          <tr>
                            <td>6.00- 6.45 AM</td>
                            <td>Disease Specific Yoga(Prerana Mandir)</td>
                          </tr>
                          <tr>
                            <td>6.15-7.00 AM</td>
                            <td>General Yoga(Yogasadhana Hall)</td>
                          </tr>
                          <tr>
                            <td>7.15-7.30 AM</td>
                            <td>Herbal Tea</td>
                          </tr>
                          <tr>
                            <td>7.30-10.30 AM</td>
                            <td>Massage and Hydrotherapy Treatments</td>
                          </tr>
                          <tr>
                            <td>8.00-9.00 AM</td>
                            <td>Juices</td>
                          </tr>
                          <tr>
                            <td>10.30-12.00 PM</td>
                            <td>Naturopathy Lunch(Annapoorna)</td>
                          </tr>
                          <tr>
                            <td>12-2.15 PM</td>
                            <td>Rest</td>
                          </tr>
                          <tr>
                            <td>3.00-3.15 PM</td>
                            <td>Herbal Tea</td>
                          </tr>
                          <tr>
                            <td>3.00-5.00 PM</td>
                            <td>Hydrotherapy treatments</td>
                          </tr>
                          <tr>
                            <td>4.00-4.30 PM</td>
                            <td>Juices</td>
                          </tr>
                          <tr>
                            <td>4.30-5.30 PM</td>
                            <td>Health Discourses</td>
                          </tr>
                          <tr>
                            <td>5.30-6.30 PM</td>
                            <td>Naturopathy Dinner</td>
                          </tr>
                          <tr>
                            <td>6.30-7.15 PM</td>
                            <td>Rest And Leisure Time</td>
                          </tr>
                          <tr>
                            <td>7.15-7.45PM</td>
                            <td>Prayer(Yogasadhana Hall)</td>
                          </tr>
                          <tr>
                            <td>7.45-8.30PM</td>
                            <td>Meditation/Trataka(Yogasadhana Hall)</td>
                          </tr>
                          <tr>
                            <td>8.30-9.30 PM</td>
                            <td>Recreation and Leisure</td>
                          </tr>
                          <tr>
                            <td>9.30 PM</td>
                            <td>Bed Time</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="elementor-column elementor-col-16 elementor-top-column elementor-element elementor-element-515f744"
                data-id="515f744" data-element_type="column">
                <div class="elementor-widget-wrap"></div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg mt-5 mb-5 ttm-bgcolor-whiteecolor"></div>
</div> -->

<div class="ttm-bgcolor-whiteecolor" *ngIf="section == 'AdayAtAshram'">
  <!-- Title Section -->
  <div class="ttm-page-title-row ttm-bgcolor-whiteecolor">
    <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="title-box ">
            <div class="page-title-heading text-white">
              <h1 class="title text-white">A day At Ashram</h1>
            </div><!-- /.page-title-captions -->
          </div>
        </div><!-- /.col-md-12 -->
      </div><!-- /.row -->
    </div><!-- /.container -->
  </div>

  <!-- Schedule Table -->
  <div class="container mt-2" style="max-width: 960px; margin: auto;">
    <div style="background-color: #ffffff; border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.1); padding: 20px;">
      <table style="width: 100%; border-collapse: collapse;">
        <thead>
          <tr style="background-color: #f0f4f8; color: #333;">
            <th style="padding: 12px 16px; text-align: center; font-size: 16px;">Timing</th>
            <th style="padding: 12px 16px; text-align: center; font-size: 16px;">Activity</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of daySchedule; let i = index"
            [style.background-color]="i % 2 === 0 ? '#ffffff' : '#f9f9f9'">
            <td style="padding: 10px 16px; border-bottom: 1px solid #eee; font-size: 16px;">{{ item.time }}</td>
            <td style="padding: 10px 16px; border-bottom: 1px solid #eee; font-size: 16px;">{{ item.activity }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Things to Carry -->
<div class=" ttm-bgcolor-whiteecolor" *ngIf="section == 'ThingstoCarry'">
  <div class="ttm-page-title-row ttm-bgcolor-whiteecolor">
    <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="title-box ">
            <div class="page-title-heading text-white">
              <h1 class="title text-white">Things to Carry</h1>
            </div><!-- /.page-title-captions -->
          </div>
        </div><!-- /.col-md-12 -->
      </div><!-- /.row -->
    </div><!-- /.container -->
  </div>
  <div class="container ttm-bgcolor-whiteecolor ">
    <div class="row mt-4">
      <section
        class="elementor-section elementor-top-section elementor-element elementor-element-8a00b45 p-spacing elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8a00b45" data-element_type="section">
        <div class="elementor-container elementor-column-gap-default">
          <div
            class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-c258b39"
            data-id="c258b39" data-element_type="column">
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-0afd2ff elementor-widget elementor-widget-text-editor animated fadeInUp">
                <div class="elementor-widget-container text-left ml-5 mt-4" style="font-size: 20px;">
                  <p><i class="fa fa-check" aria-hidden="true"></i> Personal identity proof: Aadhaar Card for Indian
                    Nationals and Passport, Visa or OCI for Foreign Nationals.</p>
                  <p><i class="fa fa-check" aria-hidden="true"></i>Government-issued photo ID with address proof such as
                    Aadhaar Card, Driving License, or Passport.</p>
                  <p><i class="fa fa-check" aria-hidden="true"></i>Proof of online booking and advance receipt or
                    confirmation details sent by Nisargopchar Ashram.</p>
                  <p><i class="fa fa-check" aria-hidden="true"></i>Recent medical reports and current medications.</p>
                  <p><i class="fa fa-check" aria-hidden="true"></i>Glucometer, if you are a diabetic.</p>
                  <p><i class="fa fa-check" aria-hidden="true"></i>Comfortable, loose-fitting cotton clothes suitable
                    for yoga and treatments such as track pants and T-shirts.</p>
                  <p><i class="fa fa-check" aria-hidden="true"></i>A shawl or light jacket, as it may get cool during
                    mornings or evenings.</p>
                  <p><i class="fa fa-check" aria-hidden="true"></i>Winter clothing during October to February, or
                    woollen clothes during monsoon and winter seasons.</p>
                  <p><i class="fa fa-check" aria-hidden="true"></i>An umbrella and appropriate footwear for monsoon use.
                  </p>
                  <p><i class="fa fa-check" aria-hidden="true"></i>A bed sheet for massage treatments.</p>
                  <p><i class="fa fa-check" aria-hidden="true"></i>Easy-to-remove, non-slip chappals or sandals.</p>
                  <p><i class="fa fa-check" aria-hidden="true"></i>Comfortable walking shoes.</p>
                  <p><i class="fa fa-check" aria-hidden="true"></i>Basic toiletries and personal care items.</p>
                  <p><i class="fa fa-check" aria-hidden="true"></i>A towel for daily use.</p>
                  <p><i class="fa fa-check" aria-hidden="true"></i>Mosquito repellent cream such as Good Knight or
                    Odomos.</p>
                  <p><i class="fa fa-check" aria-hidden="true"></i>A refillable water bottle.</p>
                  <p><i class="fa fa-check" aria-hidden="true"></i>A 200 ml mug for juices.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
  <div class="col-lg mt-5 mb-5 ttm-bgcolor-whiteecolor"></div>
</div>

<!-- Rules And Regulations -->
<!-- <div class=" ttm-bgcolor-whiteecolor" *ngIf="section == 'Rules'">
  <div class="ttm-page-title-row ttm-bgcolor-whiteecolor">
    <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="title-box ">
            <div class="page-title-heading text-white">
              <h1 class="title text-white">Rules And Regulations</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container ttm-bgcolor-whiteecolor">
    <div class="row mt-5 ">
      <div class="max-w-4xl mx-auto p-6 rounded-xl shadow-md">
        <h2 class="text-2xl font-bold text-gray-800 mb-4 text-center">🕉️ Ashram Guidelines</h2>

        <div *ngFor="let section of guidelines">
          <h2 class="text-lg text-gray-700 mt-6 mb-2 border-b pb-1">{{ section.title }}</h2>
          <ul class="list-disc list-inside space-y-1 text-gray-700" style="font-size: 16px;">
            <p *ngFor="let point of section.points">{{ point }}</p>
          </ul>
        </div>
      </div>
      <div data-elementor-type="wp-page" data-elementor-id="3786" class="elementor elementor-3786"
        data-elementor-post-type="page">
        <section
          class="elementor-section elementor-top-section elementor-element elementor-element-b8c2bcb p-spacing elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="b8c2bcb" data-element_type="section">
          <div class="elementor-container elementor-column-gap-default">
          </div>
        </section>
      </div>
    </div>
  </div>
  <div class="col-lg mt-5 mb-5 ttm-bgcolor-whiteecolor"></div>
</div> -->

<div class=" ttm-bgcolor-whiteecolor" *ngIf="section === 'Rules'"
  style="background-color: #f7f9fb; padding: 40px 20px;">
  <!-- Title Section -->
  <div style="text-align: center; margin-bottom: 40px;">
    <h1 style="font-size: 36px; color: #2c3e50; margin-bottom: 10px;">Rules and Regulations</h1>
    <p style="font-size: 18px; color: #555;">Please follow the ashram's guidelines for a peaceful and respectful stay
    </p>
  </div>

  <!-- Content Box -->
  <div style="
    max-width: 900px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    padding: 30px 40px;
  ">
    <h2 style="font-size: 24px; color: #000000; text-align: center; margin-bottom: 30px;">
      Ashram Guidelines
    </h2>

    <!-- Loop through sections -->
    <div *ngFor="let section of guidelines" style="margin-bottom: 30px;">
      <h3 style="
        font-size: 20px;
        color: #DC143C;
        border-bottom: 2px solid #ecf0f1;
        padding-bottom: 8px;
        margin-bottom: 15px;
      ">
        {{ section.title }}
      </h3>

      <ul style="padding-left: 20px; margin: 0;">
        <li *ngFor="let point of section.points" style="
          font-size: 16px;
          color: #555;
          margin-bottom: 10px;
          line-height: 1.6;
        ">
          {{ point }}
        </li>
      </ul>
    </div>
  </div>
</div>

<!---Location-->

<!-- <div class="ttm-bgcolor-whiteecolor" *ngIf="section == 'Location'">

  <div class="container ttm-bgcolor-whiteecolor"> -->
<!-- <div class="row mt-5">
      <div class="elementor-widget-container">
        <p class="para-color mt-4 mr-5"
          style="text-align:justify; display:inline-block; width:75%; text-align: center; font-size: 16px;">
          <b>Uruli Kanchan</b> is a town situated on Pune Solapur Highway. Nisargopchar
          Ashram is located in Urulikanchan in a picturesque 30 acre land 2 km away from
          Urulikanchan Busstop.
          Pune Airport is located at 30km and Pune Railway station is 35 km from the Ashram and can be
          accessed by
          cab and auto rickshaw services.
          Uruli Railway station is 2km away from Ashram.
        </p>
      </div>
    </div> -->

<!-- <div class="mt-4">
      <div class="elementor-element mt-2 text-center" data-id="1e760b8" data-element_type="widget"
        data-widget_type="text-editor.default">
        <div class="elementor-widget-container">
          <div class="map-container">
            <iframe loading="lazy" style="border: 0; width: 100%; height: 450px"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.796385024599!2d74.13082399999999!3d18.492880000000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2e0c836fc0b73%3A0xcce595bfddbf52fb!2sNisargopchar+Ashram!5e0!3m2!1sen!2sin!4v1437116886614"
              width="100%" height="100%" frameborder="0" allowfullscreen="allowfullscreen"
              data-rocket-lazyload="fitvidscompatible" class="lazyloaded" data-ll-status="loaded"></iframe>
          </div>
          <noscript>
            <iframe style="border: 0"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.796385024599!2d74.13082399999999!3d18.492880000000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2e0c836fc0b73%3A0xcce595bfddbf52fb!2sNisargopchar+Ashram!5e0!3m2!1sen!2sin!4v1437116886614"
              width="100%" height="450" frameborder="0" allowfullscreen="allowfullscreen"></iframe>
          </noscript>
        </div>
      </div>
    </div> -->

<!-- </div>
  <div class="col-lg mt-5 mb-5 ttm-bgcolor-whiteecolor"></div>
</div> -->

<div class="ttm-bgcolor-whiteecolor" *ngIf="section == 'Location'" style="background-color: #f8f9fa;">
  <!-- Title Section -->
  <!-- <div style="background: linear-gradient(135deg, #2a5298, #1e3c72); padding: 40px 0;">
    <div class="container">
      <h1 style="color: white; font-size: 2.5rem; font-weight: bold; text-align: center; margin: 0;">
        Location
      </h1>
    </div>
  </div> -->
  <div class="ttm-page-title-row ttm-bgcolor-whiteecolor">
    <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="title-box ">
            <div class="page-title-heading text-white">
              <h1 class="title text-white">Location</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Description -->
  <div class="container" style="max-width: 1000px; margin-top: 40px; text-align: left;">
    <p
      style="font-size: 16px; line-height: 1.8; color: #444; background: white; padding: 20px; border-radius: 12px; box-shadow: 0 4px 15px rgba(0,0,0,0.08);">
      <b>Uruli Kanchan</b> is a town situated on Pune Solapur Highway. Nisargopchar
      Ashram is located in Urulikanchan in a picturesque 30 acre land 2 km away from
      Urulikanchan Busstop.<br><br>
      Pune Airport is located at 30km and Pune Railway station is 35 km from the Ashram
      and can be accessed by cab and auto rickshaw services.
      Uruli Railway station is 2km away from Ashram.
    </p>
  </div>

  <!-- Map Section -->
  <div class="container" style="max-width: 1000px; margin-top: 30px; text-align: center;">
    <div style="border-radius: 12px; overflow: hidden; box-shadow: 0 5px 25px rgba(0,0,0,0.15);">
      <iframe loading="lazy" style="border: 0; width: 100%; height: 450px;"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.796385024599!2d74.13082399999999!3d18.492880000000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2e0c836fc0b73%3A0xcce595bfddbf52fb!2sNisargopchar+Ashram!5e0!3m2!1sen!2sin!4v1437116886614"
        allowfullscreen>
      </iframe>
    </div>
  </div>

  <!-- Spacer -->
  <!-- <div style="height: 50px;"></div> -->
</div>


<!--- Nature Cure -->

<div class="ttm-bgcolor-whiteecolor" *ngIf="section == 'NatureCure'">
  <div class="ttm-page-title-row ttm-bgcolor-whiteecolor">
    <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="title-box ">
            <div class="page-title-heading text-white">
              <h1 class="title text-white">Nature Cure</h1>
            </div><!-- /.page-title-captions -->
          </div>
        </div><!-- /.col-md-12 -->
      </div><!-- /.row -->
    </div><!-- /.container -->
  </div>
  <section class="ttm-bgcolor-whiteecolor clearfix mt-3">
    <div class="container">
      <div class="row">
        <div
          class="col-lg-6 col-md-12 col-sm-12 featured-imagebox featured-imagebox-service ttm-box-view-top-image mt-40">
          <div class="ttm-box-bottom-content mt-5 ttm-bgcolor-whiteecolor">
            <div class="featured-icon">
              <div
                class="ttm-icon ttm-icon_element-fill ttm-icon_element-background-color-skincolor ttm-icon_element-size-md ttm-icon_element-style-rounded">
                <i class="flaticon flaticon-meditation"></i>
              </div>
            </div>

            <div class="col-lg mt-3 mb-"></div>
            <div class="featured-desc ml-2" style="text-align:center;">
              <!-- Changed text-align to center -->
              <p class="para-color mt-2" style="text-align:justify; display:inline-block; width:95%;  font-size: 16px;">
                There are different medical approaches for various diseases all over the world like
                conventional Modern
                Medicine, Ayurveda, Yoga, Chinese system, Unani, Tibetan, Acupuncture &amp; Acupressure.
                These medical
                systems are based on some philosophy and importance in prevention and management of
                health problems.</p>
              <p class="para-color mt-2" style="text-align:justify; display:inline-block; width:95%;  font-size: 16px;">
                Modern medicine is mainly aimed at symptomatic treatment and removal of the causative
                organism or toxin
                by some medicine. Other traditional ancient systems correct the imbalance of different
                humors or energy
                principles in the human body. In fact all acute symptoms such as fever, body ache,
                hyperacidity,
                diarrhea is natures attempt to eliminate toxins &amp; waste matter from the body.
                Suppression of the
                symptoms leads to manifestation and recurrence of the same symptom or disease which is
                the cause of
                chronic disease. All such acute or chronic diseases manifest because of our faulty way
                of eating, living
                habits and negative thinking. Repeated negative impact on the body lowers the body
                resistance or
                immunity which is known as “Vital Force “.</p>
              <p class="para-color mt-2" style="text-align:justify; display:inline-block; width:95%;  font-size: 16px;">
                Main aim of the nature cure treatment is to educate the people and create
                awareness about health and hygiene. In Naturopathy we emphasize on educating a person
                about the right
                way of living and management of health problems by simple ways.</p>

              <p class="para-color mt-2" style="text-align:justify; display:inline-block; width:95%;  font-size: 16px;">
                People experience the effect of living in accordance with the laws of
                Nature. By following the laws of Nature, vitality improves, which helps in elimination
                of toxins from
                the body.</p>
              <p class="para-color mt-2" style="text-align:justify; display:inline-block; width:95%;  font-size: 16px;">
                Natural food such as Fruits, Vegetable in the form of Juices - Salad -
                Sprouts - Boiled vegetables - Baked potatoes - Sweet potatoes are used as a medicine.
                All natural food
                stuffs are rich in natural water, vitamins, minerals and roughage. It helps in
                eliminating toxins
                through increased quantity of urine, proper bowel movements through regulation of breath
                improved
                metabolism. Natural food corrects imbalance in metabolism blood sugar, blood urea, uric
                acid,
                cholesterol, lipids etc ; which is achieved without drugs.</p>
              <p class="para-color mt-3"
                style="text-align:justify; display:inline-block; width:100%;  font-size: 16px;">
                The treatment is based on five natural elements i.e. Ether (Aakash), Sunlight
                (Tej), Air (Vayu), Water (Jal) and Earth (Prithvi).</p>

            </div>

          </div>

        </div>
        <div
          class="col-lg-6 col-md-12 col-sm-12 featured-imagebox featured-imagebox-service ttm-box-view-top-image mt-40 ">
          <div class="ttm-box-bottom-content mt-5 ttm-bgcolor-whiteecolor">
            <div class="featured-icon">
              <div
                class="ttm-icon ttm-icon_element-fill ttm-icon_element-background-color-skincolor ttm-icon_element-size-md ttm-icon_element-style-rounded">
                <i class="flaticon flaticon-meditation"></i>
              </div>
            </div>
            <img class="w-60 text-center img-fluid   " src="assets/img/nature1.png" alt="First slide" width="500"
              height="250">
            <br>
            <img class="w-60 text-center img-fluid   mt-4" src="assets/img/nature2.jpeg" alt="First slide" width="700"
              height="300">
            <br>
            <img class="w-60 text-center img-fluid   mt-4" src="assets/img/nature3.jpeg" alt="First slide" width="700"
              height="300">
            <br>
            <img class="w-60 text-center img-fluid   mt-4" src="assets/img/nature4.jpeg" alt="First slide" width="700"
              height="300">
            <!-- Adjusted width and height attributes -->
          </div>
          <div class="ttm-box-bottom-content mt-5 ttm-bgcolor-whiteecolor">
            <div class="featured-icon">
              <div
                class="ttm-icon ttm-icon_element-fill ttm-icon_element-background-color-skincolor ttm-icon_element-size-md ttm-icon_element-style-rounded">
                <i class="flaticon flaticon-meditation"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ttm-bgcolor-whiteecolor">
        <div class="accordion-wrapper">
          <div class="">
            <div class="col-xl">

              <div class="mb-4" id="accordion-5" role="tablist" aria-multiselectable="true">
                <div class="accordion-with-arrow">
                  <div class="card border-primary">
                    <div class="card-header bg-primary" role="tab" id="heading-13">
                      <h5 class="mb-0">
                        <a class="accordion-toggle text-left text-white" data-toggle="collapse"
                          data-target="#collapse-13" aria-expanded="true" aria-controls="collapse-13">
                          Ether (Aakash)
                        </a>
                      </h5>
                    </div>
                    <div id="collapse-13" class="collapse show" role="tabpanel" aria-labelledby="heading-13"
                      data-parent="#accordion-5">
                      <div class="card-body">
                        <p>Fasting, low caloric food like millets, papaya, oranges, leafy
                          vegetables, lower the earth element (heaviness) in the body. Lot of
                          open space and greenery for individuals to soothe the mind, body and
                          soul.</p>
                      </div>
                    </div>
                  </div>
                  <div class="card border-primary">
                    <div class="card-header bg-primary" role="tab" id="heading-14">
                      <h5 class="mb-0">
                        <a class="collapsed accordion-toggle text-left text-white" data-toggle="collapse"
                          data-target="#collapse-14" aria-expanded="false" aria-controls="collapse-14">
                          Sunlight (Tej)
                        </a>
                      </h5>
                    </div>
                    <div id="collapse-14" class="collapse" role="tabpanel" aria-labelledby="heading-14"
                      data-parent="#accordion-5">
                      <div class="card-body">
                        <p>Sunlight is essential for plants & animals for proper growth and is a
                          source of energy for universe. Sunbath and proper combination of
                          food is necessary for proper digestion and metabolism.</p>
                      </div>
                    </div>
                  </div>
                  <div class="card border-primary">
                    <div class="card-header bg-primary" role="tab" id="heading-15">
                      <h5 class="mb-0">
                        <a class="collapsed accordion-toggle text-left text-white" data-toggle="collapse"
                          data-target="#collapse-15" aria-expanded="false" aria-controls="collapse-15">
                          Air (Vayu)
                        </a>
                      </h5>
                    </div>
                    <div id="collapse-15" class="collapse" role="tabpanel" aria-labelledby="heading-15"
                      data-parent="#accordion-5">
                      <div class="card-body">
                        <p>Sunlight is essential for plants & animals for proper growth and is a
                          source of energy for universe. Sunbath and proper combination of
                          food is necessary for proper digestion and metabolism.</p>
                      </div>
                    </div>
                  </div>
                  <div class="card border-primary">
                    <div class="card-header bg-primary" role="tab" id="heading-16">
                      <h5 class="mb-0">
                        <a class="collapsed accordion-toggle text-left text-white" data-toggle="collapse"
                          data-target="#collapse-16" aria-expanded="false" aria-controls="collapse-16">
                          Water (Jal)
                        </a>
                      </h5>
                    </div>
                    <div id="collapse-16" class="collapse" role="tabpanel" aria-labelledby="heading-16"
                      data-parent="#accordion-5">
                      <div class="card-body">
                        <p>All plants and animals needs water for their survival. Any imbalance
                          leads to disease. Water is used internally and externally for
                          various treatments and purification of body.</p>
                      </div>
                    </div>
                  </div>
                  <div class="card border-primary">
                    <div class="card-header bg-primary" role="tab" id="heading-17">
                      <h5 class="mb-0">
                        <a class="collapsed accordion-toggle text-left text-white" data-toggle="collapse"
                          data-target="#collapse-17" aria-expanded="false" aria-controls="collapse-17">
                          Earth (Prithvi)
                        </a>
                      </h5>
                    </div>
                    <div id="collapse-17" class="collapse" role="tabpanel" aria-labelledby="heading-17"
                      data-parent="#accordion-5">
                      <div class="card-body">
                        <p>Plants, Vegetables are necessary for sustenance of animals. Earth
                          imparts different qualities to food stuffs along with other
                          elements. Soil is used for external application and for mud packs..
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="col-lg mt-5 mb-5 ttm-bgcolor-whiteecolor"></div>
</div>


<!--- Testimonials --->

<div class="ttm-bgcolor-whiteecolor" *ngIf="section == 'Testimonials'">
  <div class="ttm-page-title-row ttm-bgcolor-whiteecolor">
    <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="title-box ">
            <div class="page-title-heading text-white">
              <h1 class="title text-white">Testimonials</h1>
            </div><!-- /.page-title-captions -->
          </div>
        </div><!-- /.col-md-12 -->
      </div><!-- /.row -->
    </div><!-- /.container -->
  </div>
  <div class="container ttm-bgcolor-whiteecolor">
    <div class="row mt-5">
      <div _ngcontent-xch-c4="" class="testimonial-wrap py-4" dir="ltr">
        <div _ngcontent-xch-c4="" class="container">
          <div _ngcontent-xch-c4="" class="testimonial-slider">
            <div _ngcontent-xch-c4="" class="card shadow-box border p-4">
              <ngx-slick-carousel _ngcontent-xch-c4="" ng-reflect-config="[object Object]"
                class="slick-initialized slick-slider slick-dotted">
                <!-- Add your slides here -->
                <div class="row  container-fluid ">
                  <div class="col">
                    <div id="multi-item-carousel" class="carousel slide mt-4 align-items-right" data-ride="carousel">
                      <div class="carousel-inner">
                        <div class="carousel-item active">

                          <div class="row">
                            <div class="col-md" *ngFor="let text of text.slice(0, 1)">
                              <!-- <img [src]="image" class="d-block w-30" alt="Slide"> -->
                              <h1 style="font-size: 1rem;">{{text.feedback}}</h1>
                              <img decoding="async" style="width: 10%;" [src]="text.Image" alt="DR. H. R. NAGENDRA "
                                class="lazyloaded" data-ll-status="loaded">
                              <a style="font-size: 1rem;">{{text.Name}}</a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <a class="carousel-control-prev" href="#multi-item-carousel" role="button" data-slide="prev "
                        (click)="prevSlide()">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                      </a>
                      <a class="carousel-control-next" href="#multi-item-carousel" role="button" data-slide="next"
                        (click)="nextSlide()">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                      </a>
                    </div>
                  </div>
                </div>
                <ul class="slick-dots" role="tablist">
                  <!-- Dot indicators for slides -->
                  <li class="" role="presentation"><button type="button" role="tab" id="slick-slide-control30"
                      aria-controls="slick-slide30" aria-label="1 of 3" tabindex="-1">1</button></li>
                  <li role="presentation" class=""><button type="button" role="tab" id="slick-slide-control31"
                      aria-controls="slick-slide31" aria-label="2 of 3" tabindex="-1">2</button></li>
                  <li role="presentation" class="slick-active"><button type="button" role="tab"
                      id="slick-slide-control32" aria-controls="slick-slide32" aria-label="3 of 3" tabindex="0"
                      aria-selected="true">3</button>
                  </li>
                </ul>
              </ngx-slick-carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--- Workshops / Seminars --->

<div class="ttm-bgcolor-whiteecolor" *ngIf="section == 'Workshops'">
  <div class="ttm-page-title-row ttm-bgcolor-whiteecolor">
    <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="title-box ">
            <div class="page-title-heading text-white">
              <h1 class="title text-white">Workshops / Seminars</h1>
            </div><!-- /.page-title-captions -->
          </div>
        </div><!-- /.col-md-12 -->
      </div><!-- /.row -->
    </div><!-- /.container -->
  </div>
  <div class="container mt-4">
    <div class="row text-center mt-3">
      <p>December 12 - 13, 2014</p>
    </div>
    <div class="row">
      <h1> WORKSHOP ON “RELEVANCE OF GANDHIJI AMONG YOUNGER GENERATION”</h1>
    </div>
    <div class="row mt-4"><!-- row -->
      <div class="col-md-6 col-lg-4">
        <!-- featured-imagebox -->
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail"><!-- team-member-image -->
              <img class="img-fluid" src="assets/img/workshop1.jpeg" alt="">
            </div>
          </div>
          <div class="title-desc mt-2">
            <p class="para-color mt-2" style="text-align:justify; font-size: 16px;">Orientation of school
              children of Urulikanchan area, Haveli
              taluka, Pune district, on Gandhian values under the inspiring presence of veteran Gandhian
              Shri.
              Subba Rao, President, National Youth Programme, Gandhi Peace Foundation, Delhi.</p>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <!-- featured-imagebox -->
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail"><!-- team-member-image -->
              <img class="img-fluid" src="assets/img/workshop2.jpeg" alt="">
            </div>
          </div>
          <div class="title-desc mt-2">
            <p class="para-color mt-2" style="text-align:justify; font-size: 16px;">Jamuben Chaudhari,
              veteran Sarvodaya leader associated with Vinoba Ashram in Gujarat and Jyotibai Patankar,
              Brahma Vidya Mandir, Pavnar, Wardha engage school children in a role play on Gandhian values
              at the Mahatma Gandhi Vidyalaya at Urulikanchan.</p>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <!-- featured-imagebox -->
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail"><!-- team-member-image -->
              <img class="img-fluid" src="assets/img/workshop3.jpeg" alt="">
            </div>
          </div>
          <div class="title-desc mt-2">
            <p class="para-color mt-2" style="text-align:justify; font-size: 16px;">School children
              enthusiastically participate in the youth progamme being conducted by Shri. Subba Rao,
              President, National Youth Programme, Gandhi Peace Foundation, Delhi.</p>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 mt-3">
        <!-- featured-imagebox -->
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail"><!-- team-member-image -->
              <img class="img-fluid" src="assets/img/workshop4.jpeg" alt="">
            </div>
          </div>
          <div class="title-desc mt-2">
            <p class="para-color mt-2" style="text-align:justify; font-size: 16px;">Pradyna Patil, a youth,
              teaching tribal children in Karjat area, shares her views on Gandhian values.</p>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 mt-3">
        <!-- featured-imagebox -->
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail"><!-- team-member-image -->
              <img class="img-fluid" src="assets/img/workshop5.jpeg" alt="">
            </div>
          </div>
          <div class="title-desc mt-2">
            <p class="para-color mt-2" style="text-align:justify; font-size: 16px;">Smt. Jyotibai Patankar,
              Brahma Vidya Mandir, Pavnar, Wardha addresses the youth and Gandhian thinkers at the two-day
              seminar.</p>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 mt-3">
        <!-- featured-imagebox -->
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail"><!-- team-member-image -->
              <img class="img-fluid" src="assets/img/workshop6.jpeg" alt="">
            </div>
          </div>
          <div class="title-desc mt-2">
            <p class="para-color mt-2" style="text-align:justify; font-size: 16px;">Dr. Radhaben Bhat,
              President, Gandhi Peace Foundation, New Delhi and founder of Lakshmi Ashram, Kausal,
              Uttarakhand, addresses the youth and Gandhian thinkers and Sarvodaya leaders at the two-day
              seminar.</p>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 mt-3">
        <!-- featured-imagebox -->
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail"><!-- team-member-image -->
              <img class="img-fluid" src="assets/img/workshop7.jpeg" alt="">
            </div>
          </div>
          <div class="title-desc mt-2">
            <p class="para-color mt-2" style="text-align:justify; font-size: 16px;">Release of the Marathi
              book “Positive Attitude for Good Health and Happiness” by Shri. Subba Rao. Also seen (from l
              to r): Smt. Jyotibai Patankar, Brahma Vidya Mandir, Pavnar, Wardha, Dr. Radhaben Bhat,
              President, Gandhi Peace Foundation, Delhi and founder, Lakshmi Ashram, Kausal, Uttarakhand,
              Shri. Subba Rao, President, National Youth Programme, Gandhi Peace Foundation, Delhi, Shri.
              Amarnathbhai, Sarvoseva Sangh, Benaras, Author of the book, Dr. Narayan Hegde and Marathi
              translator, Prof. Arvind Khire.</p>
          </div>
        </div>
      </div>

    </div><!-- row end -->
    <div class="row mt-3 ml-2 mr-2">
      <h1><strong>SUMMARY</strong></h1>
      <p class=""
        style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
        The Gram Rajya Trust at Uruli kanchan, near Pune in association with the Nisargopachar
        Gramsudhar Trust,
        popularly known as the Nature Cure Ashram, organized a workshop on
        <strong>“Relevance of Gandhiji among Younger Generation”</strong> from December 12 to 13, 2014 at the
        Nature Cure Ashram founded by Mahatma Gandhi at Uruli kanchan.
      </p>
      <p class=""
        style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
        The objective was to evolve a methodology for promoting Gandhian values among youth and
        orienting them about the principles of Sarvodaya for holistic development.</p>
      <p class=""
        style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
        The workshop was inaugurated by Gandhian practitioner Shri. Subba Rao, President,
        National Youth Programme, Gandhi Peace Foundation, New Delhi in the presence of Dr. Radhaben Bhat,
        President, Gandhi Peace Foundation, New Delhi and founder of Lakshmi Ashram, Kausal, Uttarakhand, Smt.
        Jyoti Patankar, Brahma Vidya Mandir, Pavnar, Wardha, veteran Gandhian, Shri. Rambhau Mhaske, Paramdham
        Prakashan, Pavnar, Shri. Amarnathbhai, Sarvoseva Sangh, Benaras, Shri. Jaywant Mathkar, President,
        Sevagram Ashram, Wardha, Dr. Narayan Hegde, Managing Trustee, Gram Rajya Trust and Nisargopachar
        Gramsudhar Trust, Urulikanchan, Dr. Ravindra V. Nisal, Director, Nisargopachar Ashram, Urulikanchan and
        other like-minded Gandhian thinkers from Maharashtra, Gujarat, Madhya Pradesh, Bihar, Uttar Pradesh and
        Tamil Nadu.</p>
      <p class=""
        style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
        Dr. Hegde in his welcome address, traced the association of Mahatma Gandhi with the
        Nisargopachar Ashram, chanting of Ramanama as advocated by Gandhiji as the most effective natural
        therapy for curing all ailments and the motivational book “Unto this Last” by John Ruskin which endorsed
        his convictions about the role of every person in building society, importance of working for the good
        of all while recognizing dignity of labour, apart from the Bhagavad Gita which was the basis of
        Gandhiji’s thoughts. Dr. Hegde further emphasized the need to ensure a balance between mental and
        physical health as propagated by the followers of Gandhiji and foremost Trustees of the Ashram, namely
        Shri. Balkoba Bhave, younger brother of Acharya Vinoba Bhave, Shri. Krishnachandra Agarwal and Dr.
        Manibhai Desai and the birth of BAIF in 1967 to bring poor farmers out of poverty and thereby keep alive
        the concept of Sarvodaya, the Gandhian approach to Rural Development. He further added that this
        approach could serve as the most critical link between the younger generation and veteran Gandhian
        practitioners.</p>
      <p class=""
        style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
        Shri. Subba Rao, President, National Youth Programme, Gandhi Peace Foundation, New
        Delhi defined youth as “one who is confident and strong” and who apart from realising the inner strength
        of Gandhiji also need to know that they are part of a great revolution wherein peace, calmness and
        morality as stated in the Upanishads need to be revived. He quoted the sacrifice of martyrs such as
        Khudiram Bose and Bhagat Singh and the need to inspire youth with their heroic deeds and to reach the
        messages of Gandhiji to them for their development.</p>
      <p class=""
        style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
        Smt. Radhaben Bhat, President, Gandhi Peace Foundation, New Delhi and founder of Lakshmi Ashram, Kausal,
        Uttarakhand,emphasized the need to express confidence in youth and to motivate them. Today, their
        journey is from village to urban areas and from urban areas to foreign countries, she lamented. She
        pointed out the need to promote khadi as a way of life rather than as a business and admitted the
        absence of the role of children in the Sarvodaya movement and further added that only if the village was
        saved could the country be saved. She also urged the youth to discuss and debate about life and to adopt
        the ashram way of living and need for spiritual orientation. It was necessary to make a centralized
        effort instead of working in isolation, she concluded.</p>
      <P class=""
        style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
        “Gandhian thoughts are the only reality today”, stated Smt. Jyotibai Patankar, Brahma
        Vidya Mandir, Pavnar, Wardha, while lamenting that Gandhian ideals and service to poor are dying and
        hence the need for youth to realize Gandhian thoughts and for imbibing Gandhian principles in their
        lives. She felt that it was the duty of society to give directions to youth to lead a good life and also
        felt that a diploma course for better education and village development could be introduced and school
        could be a medium for spreading Gandhian values.</P>
      <p class=""
        style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
        Shri. Kumar Saptarshi, Gandhi Foundation, Pune urged society not to fulfil their
        unachieved targets through children and to avoid making undue demands on children. Shri. Amarnathbhai,
        Sarvoseva Sangh, Benaras, highlighted the development taking place in society where the future was bleak
        due to the presence of jobless youth with an element of ruthlessness, directionless with no ideal in
        front of them and thought it essential to create an opportunity whereby Gandhian veterans can live and
        interact with youth who can imbibe values from them.</p>
      <P class=""
        style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
        Shri. Jaywant Matkar, Sevagram Ashram, Wardha stated that schools and colleges could
        be effective medium for transferring Gandhian thoughts to school children while other Gandhian scholars
        and Sarvodaya leaders present at the seminar identified the burden of mental health as a matter of
        concern and the need for publicity and not propaganda for involvement of youth. Need to become young
        mentally in order to inspire the youth was identified as an important challenge apart from vibrant
        health, economic security and a sense of purpose in life. Orientation of organizations, high schools and
        colleges, part-time volunteers and conducting camps, instituting Gandhi Fellowships, documentation and
        identifying a suitable programme to involve youth were the other suggestions which emerged during the
        two-day seminar.</P>
      <p class=""
        style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
        Shri. Raosaheb Shinde, Chairman, Ryat Shikshan Sanstha highlighted the need to spread
        the messages of Gandhiji among youth in a simple language.</p>
      <p class="text-left">An interactive session between Gandhian leaders, Sarvodaya workers and school children,
        held at the Mahatma Gandhi Vidyalaya at Urulikanchan enabled the children to receive basic orientation
        on Gandhian values.</p>
      <p class=""
        style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
        On this occasion, the book <strong>“Positive Attitude for Good Health and
          Happiness”</strong> "written by Dr. Narayan Hegde and translated in Marathi by Prof. Arvind Khire,
        former Principal, Mahatma Gandhi Vidyalaya, was released by Dr. Subba Rao."</p>
      <p class=""
        style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
        The outcome of the seminar is being compiled into a publication and it is proposed to
        organize a meeting after a year to review the progress and plan on what every individual can do to
        involve youth in adopting Gandhian principles.</p>

    </div>
    <div class="row mt-3">
      <h1><strong>Workshops at Ashram</strong></h1>

      <div class="row  container-fluid ttm-bgcolor-whiteecolor">
        <div class="col">
          <div id="multi-item-carousel" class="carousel slide mt-4 align-items-right" data-ride="carousel">
            <div class="carousel-inner">
              <div class="carousel-item active">

                <div class="row">
                  <div class="col-md" *ngFor="let image of images.slice(0, 3)">
                    <img [src]="image" class="d-block w-10" alt="Slide">
                  </div>
                </div>
              </div>

            </div>
            <a class="carousel-control-prev" href="#multi-item-carousel" role="button" data-slide="prev "
              (click)="prevSlide()">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>

            <a class="carousel-control-next" href="#multi-item-carousel" role="button" data-slide="next"
              (click)="nextSlide()">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row mt-4">
      <div id="multi-item-carousel" class="carousel slide mt-4 align-items-right" data-ride="carousel">
        <div class="carousel-inner">
          <div class="carousel-item active">

            <div class="row">
              <div class="col-md" *ngFor="let img of img.slice(0, 3)">
                <img [src]="img" class="d-block w-8" alt="Slide">
              </div>
            </div>
          </div>

        </div>
        <a class="carousel-control-prev" href="#multi-item-carousel" role="button" data-slide="prev "
          (click)="prevSlidee()">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>

        <a class="carousel-control-next" href="#multi-item-carousel" role="button" data-slide="next"
          (click)="nextSlidee()">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
  <div class="col-lg mt-5 mb-5 ttm-bgcolor-whiteecolor"></div>
</div>